// extracted by mini-css-extract-plugin
module.exports = {"tafsirContainer":"tafsirs_tafsirContainer__DIxKj"};